<template>
  <div>
    <v-container class="pa-0" fluid>
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div v-if="enrollID" class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Enroll Teacher Request
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="9" >
         <v-card-actions>
          <router-link slot="right" :to="{ name: 'teacherEnrollment' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
          </v-col>
        </v-row>
    <!-- <div>
      <v-banner class="subtitle" single-line >
        <span class="has-text-primary-light is-size-4" v-if="enrollID">Enroll Teacher Request</span>
      <template v-slot:actions>
          <router-link slot="right" :to="{ name: 'teacherEnrollment' }">
            <v-btn normal color="white" dark class="is-caption font-weight-bold">
                <v-icon>mdi-backburger</v-icon>
              back
            </v-btn>
          </router-link>
        </template>
        </v-banner>
    </div> -->
        <v-row no-gutters>
          <v-col  >
            <v-form ref="form"  class="white lighten-5 py-5 px-5">
              <v-row>
                <v-col cols="12" md="6" lg="2">
                  Center Name :
                </v-col>
                <v-col cols="12" md="6" lg="10">
                    <!-- <div class="x-scroll" id="style-4"> -->
                    <v-chip-group column>
                      <v-chip small outlined color="primary"
                        v-for="(item, i) in enrollData.trainingRequestFranchiseeMaps" :key="i"
                        >
                        {{`${item.franchisee.companyName}`}}
                        <!-- {{enrollData.trainingRequestFranchiseeMaps ? enrollData.trainingRequestFranchiseeMaps[1].franchisee.companyName : ''}} -->
                      </v-chip>
                    </v-chip-group>
                    <!-- </div> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="6" lg="2">
                  Centre Head:
                </v-col>
                <v-col class="font-weight-medium body-2">
                  {{enrollData.createdBy}}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="6" lg="2">
                  Class Group:
                </v-col>
                <v-col class="font-weight-medium body-2">
                  {{enrollData.studentClassGroup ? enrollData.studentClassGroup.name : ''}}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="6" lg="2">
                  Training topic:
                </v-col>
                <v-col class="font-weight-medium body-2">
                  {{enrollData.training ? enrollData.training.name : ''}}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="6" lg="2">
                  Status:
                </v-col>
                <v-col class="font-weight-medium body-2">
                  {{enrollData.status}}
                </v-col>
              </v-row>
              <v-row>
                  <v-col cols="12" sm="4" md="6" lg="2">
                  Teachers :
                </v-col >
                <v-col cols="12" lg="10" md="6">
                <v-chip-group column>
                <v-chip small color="warning"
                v-for="(item, i) in enrollData.trainingRequestStaffMaps" :key="i" >
                {{`${item.userStaff.user.firstName} ${item.userStaff.user.lastName}`}}
                </v-chip>
                </v-chip-group>
                </v-col>
                    <!-- <v-list disabled>
                      <v-subheader class="subtitle-1">Teachers</v-subheader>
                      <v-list-item-group v-for="(item, i) in enrollData.trainingRequestStaffMaps" :key="i"
                        color="primary"
                      >
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon>mdi-user</v-icon>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>{{`${item.userStaff.user.firstName} ${item.userStaff.user.lastName}`}}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      <v-divider inset></v-divider>
                      </v-list-item-group>
                    </v-list> -->
              </v-row>
              <v-row>
                <v-col cols="12" lg="8" md="6">
              <v-textarea outlined hide-details class="my-0 py-1" clearable clear-icon="mdi-close-circle" label="Remark" v-model="remark" auto-grow rows="3" row-height="25"></v-textarea>
            </v-col>
                <!-- <v-col>
                   <v-textarea
                      label="Remark"
                      v-model="remark"
                      auto-grow
                      outlined
                      dense
                      rows="3"
                      row-height="25"
                    ></v-textarea>
                </v-col> -->
                <v-col sm="4" md="4" lg="4" class="mt-6" >
                  <v-btn-toggle class="d-flex justify-end ">
                     <v-btn class="px-3"
                      depressed
                      color="success py-4"
                      @click="onSubmit(1)"
                    >
                      Accept
                    </v-btn>
                    <v-btn class="px-3"
                      depressed
                      color="primary py-4"
                      @click="onSubmit(0)"
                    >
                      Reject
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
    </v-card>
    </v-container>
    <loading-icon :value="isLoading" />
  </div>
</template>

<script>
import constants from '@/utils/constants'
// import _ from 'lodash'
// import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'TeacherTrainingTopic',
  props: ['enrollID'],
  components: {
  },
  data () {
    return {
      enrollData: [],
      remark: '',
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      if (this.enrollID) {
        await this.getEnrollDetails(this.enrollID)
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    getEnrollDetails: async function (enrollID) {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/teacher-training/request/get/${enrollID}`)
        this.isLoading = false
        this.enrollData = data
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onSubmit: async function (val) {
      try {
        let transection, status
        let message = null
        if (val) {
          status = 'APPROVED'
          transection = http.get(`${constants.API_URL}/api/teacher-training/request/approve-reject?id=${this.enrollID}&&status=${status}`)
          message = `Request approved successfully!`
        } else {
          status = 'REJECTED'
          if (!this.remark) {
            return this.errMsg('Remark is required')
          }
          transection = http.get(`${constants.API_URL}/api/teacher-training/request/approve-reject?id=${this.enrollID}&&status=${status}&&remark=${this.remark}`)
          message = `Request rejected successfully!`
        }
        if (transection) {
          this.isLoading = true
          await transection
          this.isLoading = false
          this.$buefy.dialog.alert({
            message: message,
            type: 'is-success'
          })
          this.$router.push({ name: 'teacherEnrollment' })
        } else {
          return
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
 /* div.x-scroll{
  width: 100%;
  height: 75px;
  overflow-y: auto;
  }
  #style-4::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

#style-4::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #adadad;
  border: 2px solid #adadad;
}

#style-4::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
    border-radius: 10px;
} */

</style>
